import React, { useState, useEffect, useContext } from 'react';

import {
  CardsContainer,
  Card,
  Container,
} from '../../../../../components/v2/Card';
import useComponentMounted from '../../../../../hooks/useComponentMounted';
import CoachConfig from '../../../../Model/CoachConfig';
import Coach from '../../../../../Model/Coach';
import UserContext from '../../../../../context/UserContext';
import LoadingOverlay from '../../../../components/LoadingOverlay';
import WorkoutNotification from './components/WorkoutNotification';
import WorkoutAssignmentNotification from './components/WorkoutAssignmentNotification';
import MealPlanAssignmentNotification from './components/MealPlanAssignmentNotification';
import NewClientPushNotification from './components/NewClientPushNotification';
import SlackNotificationSettings from './components/SlackNotificationSettings/SlackNotificationSettings';

const NotificationSettings = () => {
  const [coachConfig, setCoachConfig] = useState(null);
  const [coachDoc, setCoachDoc] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const { userId: coachId } = useContext(UserContext);

  const isComponentMountedRef = useComponentMounted();

  useEffect(() => {
    const init = async () => {
      const [coachConfigDoc, coachDocument] = await Promise.all([
        CoachConfig.getCoachConfigByCoachId(coachId),
        Coach.getCoachById(coachId),
      ]);
      if (isComponentMountedRef.current) {
        setCoachConfig(coachConfigDoc);
        setCoachDoc(coachDocument);
        setIsLoading(false);
      }
    };
    if (coachId) {
      init();
    }
  }, [
    coachId,
    isComponentMountedRef,
  ]);

  return (
    <CardsContainer>
      <Card>
        <Container>
          <LoadingOverlay isLoading={isLoading} />
          {coachConfig && <WorkoutNotification coachConfig={coachConfig} />}
          {coachDoc && <WorkoutAssignmentNotification coachDoc={coachDoc} />}
          {coachDoc && <MealPlanAssignmentNotification coachDoc={coachDoc} />}
          {coachDoc && <NewClientPushNotification coachDoc={coachDoc} />}
        </Container>
      </Card>
      <Card>
        <Container>
          <SlackNotificationSettings />
        </Container>
      </Card>
    </CardsContainer>
  );
};

export default NotificationSettings;
